/* Nuit d'Halloween – theme.js (aucune dépendance) */
(() => {
  'use strict';

  const theme = window.theme || { routes: {}, strings: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };

  /* ---------- Prix ---------- */
  function formatMoney(cents, format = theme.moneyFormat || '{{amount}} €') {
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, decimals, thousands = ',', decimal = '.') => {
      const [int, dec] = (n / 100).toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
    };
    const match = format.match(re);
    if (!match) return format;
    const value = {
      amount: () => fmt(cents, 2),
      amount_no_decimals: () => fmt(cents, 0),
      amount_with_comma_separator: () => fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => fmt(cents, 0, '.', ','),
      amount_with_space_separator: () => fmt(cents, 2, ' ', ','),
      amount_no_decimals_with_space_separator: () => fmt(cents, 0, ' ', ','),
      amount_with_apostrophe_separator: () => fmt(cents, 2, "'", '.'),
    }[match[1]];
    return format.replace(re, value ? value() : fmt(cents, 2));
  }

  /* ---------- Hauteur du header (pour les éléments collants) ---------- */
  const header = $('[data-header]');
  if (header) {
    const setH = () => document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
    setH();
    window.addEventListener('resize', setH, { passive: true });
  }

  /* ---------- Vidéo de fond : pas d'animation si l'utilisateur l'a demandé ---------- */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('.hero__video').forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
  }

  /* ---------- Tiroirs <details> (menu mobile, filtres) ---------- */
  $$('details[data-menu-drawer], details[data-filters]').forEach((d) => {
    d.addEventListener('toggle', () => document.documentElement.classList.toggle('no-scroll', d.open));
  });

  /* ---------- Compte à rebours ---------- */
  define('countdown-timer', class extends HTMLElement {
    connectedCallback() {
      const end = new Date(this.dataset.end).getTime();
      if (Number.isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          if (this.dataset.expired) {
            this.textContent = this.dataset.expired;
            this.hidden = false;
          } else this.hidden = true;
          return;
        }
        this.querySelector('[data-d]').textContent = pad(Math.floor(diff / 864e5));
        this.querySelector('[data-h]').textContent = pad(Math.floor((diff / 36e5) % 24));
        this.querySelector('[data-m]').textContent = pad(Math.floor((diff / 6e4) % 60));
        this.querySelector('[data-s]').textContent = pad(Math.floor((diff / 1e3) % 60));
        this.hidden = false;
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });

  /* ---------- Panier (Ajax + Section Rendering API) ---------- */
  const Cart = {
    get drawer() { return $('[data-cart-drawer]'); },
    isCartPage() { return location.pathname === theme.routes.cart; },
    open() {
      const d = this.drawer;
      if (!d || this.isCartPage()) return false;
      this.lastFocus = document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      setTimeout(() => $('.drawer__panel', d)?.focus(), 60);
      return true;
    },
    close() {
      const d = this.drawer;
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      this.lastFocus?.focus?.();
    },
    sectionIds() { return [...new Set($$('[data-cart-section]').map((el) => el.dataset.cartSection))]; },
    render(sections) {
      if (!sections) return;
      $$('[data-cart-section]').forEach((el) => {
        const html = sections[el.dataset.cartSection];
        if (!html) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html')
          .querySelector(`[data-cart-section="${el.dataset.cartSection}"]`);
        if (!fresh) return;
        el.innerHTML = fresh.innerHTML;
        if (fresh.dataset.count !== undefined) {
          el.dataset.count = fresh.dataset.count;
          this.updateCount(Number(fresh.dataset.count));
        }
      });
    },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    },
    showError(message) {
      $$('[data-cart-error]').forEach((el) => { el.textContent = message; el.hidden = false; });
    },
    async request(url, options) {
      const res = await fetch(url, options);
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.cartError);
      return data;
    },
    async add(form) {
      const body = new FormData(form);
      body.append('sections', this.sectionIds().join(','));
      body.append('sections_url', location.pathname);
      const data = await this.request(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      this.render(data.sections);
      this.open();
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    },
    async change(line, quantity) {
      const scope = this.drawer?.classList.contains('is-open') ? this.drawer : document;
      scope.querySelectorAll('.cart-item').forEach((el) => el.classList.add('is-busy'));
      try {
        const data = await this.request(`${theme.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: this.sectionIds(), sections_url: location.pathname }),
        });
        this.render(data.sections);
      } catch (e) {
        this.showError(e.message);
        $$('.cart-item.is-busy').forEach((el) => el.classList.remove('is-busy'));
      }
    },
  };
  window.HalloweenCart = Cart;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && Cart.open()) { e.preventDefault(); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); Cart.close(); return; }

    const lineBtn = e.target.closest('[data-cart-qty]');
    if (lineBtn) {
      e.preventDefault();
      Cart.change(Number(lineBtn.dataset.cartQty), Math.max(0, Number(lineBtn.dataset.qty)));
      return;
    }

    const step = e.target.closest('[data-qty-btn]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const min = Number(input.min) || 1;
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + Number(step.dataset.qtyBtn));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const closer = e.target.closest('[data-menu-close]');
    if (closer) closer.closest('details')?.removeAttribute('open');
  });

  document.addEventListener('change', (e) => {
    const lineInput = e.target.closest('[data-cart-input]');
    if (lineInput) Cart.change(Number(lineInput.dataset.cartInput), Math.max(0, parseInt(lineInput.value, 10) || 0));
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    const btn = e.submitter || form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-form-error]');
    if (error) error.hidden = true;
    btn?.classList.add('is-loading');
    btn?.setAttribute('aria-busy', 'true');
    Cart.add(form)
      .catch((err) => {
        if (error) { error.textContent = err.message; error.hidden = false; } else window.alert(err.message);
      })
      .finally(() => { btn?.classList.remove('is-loading'); btn?.removeAttribute('aria-busy'); });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    Cart.close();
    $$('details[open][data-menu-drawer], details[open][data-filters]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------- Galerie produit ---------- */
  define('media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.slider = $('[data-gallery-slider]', this);
      this.thumbsWrap = $('[data-gallery-thumbs]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(t.dataset.thumb)));
      if ('IntersectionObserver' in window && this.thumbs.length) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) this.setActive(en.target.dataset.mediaId); });
        }, { root: this.slider, threshold: 0.6 });
        $$('[data-media-id]', this.slider).forEach((s) => io.observe(s));
      }
      if (this.dataset.initial) requestAnimationFrame(() => this.goTo(this.dataset.initial, 'instant'));
    }
    goTo(id, behavior = 'smooth') {
      const slide = $(`[data-media-id="${id}"]`, this.slider);
      if (!slide) return;
      this.slider.scrollTo({ left: slide.offsetLeft, behavior });
      this.setActive(String(id));
    }
    setActive(id) {
      this.thumbs.forEach((t) => {
        const on = t.dataset.thumb === String(id);
        t.classList.toggle('is-active', on);
        if (on && this.thumbsWrap) {
          this.thumbsWrap.scrollTo({ left: t.offsetLeft - this.thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
    }
  });

  /* ---------- Variantes ---------- */
  define('product-info', class extends HTMLElement {
    connectedCallback() {
      const json = $('[data-variants]', this);
      if (!json) return;
      this.variants = JSON.parse(json.textContent);
      this.section = this.dataset.section;
      this.addEventListener('change', (e) => { if (e.target.matches('[data-option]')) this.onChange(); });
      this.markAvailability(this.selected());
    }
    selected() {
      return $$('[data-option-index]', this).map((fs) => fs.querySelector('input:checked')?.value ?? null);
    }
    onChange() {
      const sel = this.selected();
      $$('[data-option-index]', this).forEach((fs, i) => {
        const label = $('[data-option-value]', fs);
        if (label) label.textContent = sel[i];
      });
      this.markAvailability(sel);
      this.update(this.variants.find((v) => v.options.every((o, i) => o === sel[i])));
    }
    markAvailability(sel) {
      $$('[data-option-index]', this).forEach((fs, i) => {
        $$('input[data-option]', fs).forEach((input) => {
          const ok = this.variants.some((v) => v.available && v.options[i] === input.value
            && v.options.every((o, j) => j === i || sel[j] === null || o === sel[j]));
          input.closest('.pill')?.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    update(v) {
      const buttons = $$(`[data-atc-for="${this.section}"]`);
      const setButtons = (text, disabled) => buttons.forEach((b) => {
        b.disabled = disabled;
        ($('[data-atc-text]', b) || b).textContent = text;
      });
      if (!v) { setButtons(theme.strings.unavailable, true); this.updateStock(null); return; }

      const form = document.getElementById(this.dataset.formId);
      const idInput = form?.querySelector('[name="id"]');
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }

      setButtons(v.available ? theme.strings.addToCart : theme.strings.soldOut, !v.available);

      const sale = v.compare > v.price;
      const pct = sale ? Math.floor(((v.compare - v.price) * 100) / v.compare) : 0;
      $$(`[data-price-for="${this.section}"]`).forEach((el) => {
        el.classList.toggle('price--sale', sale);
        el.innerHTML = `<span class="price__current">${formatMoney(v.price)}</span>`
          + (sale ? `<s class="price__compare">${formatMoney(v.compare)}</s>` : '')
          + (pct > 0 ? `<span class="badge badge--sale">-${pct}%</span>` : '');
      });

      this.updateStock(v);
      if (v.media) $(`[data-gallery="${this.section}"]`)?.goTo(v.media);

      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url);
    }
    updateStock(v) {
      const el = $(`[data-stock-for="${this.section}"]`);
      if (!el) return;
      let cls = 'is-in';
      let text = el.dataset.in;
      if (!v || !v.available) { cls = 'is-out'; text = el.dataset.out; }
      else if (v.qty !== null && v.qty > 0 && v.qty <= Number(el.dataset.threshold)) {
        cls = 'is-low';
        text = el.dataset.low.replace('[count]', v.qty);
      }
      el.className = `stock ${cls}`;
      $('[data-stock-text]', el).textContent = text;
    }
  });

  /* ---------- Barre d'achat collante ---------- */
  define('sticky-atc', class extends HTMLElement {
    connectedCallback() {
      const target = document.getElementById(this.dataset.target);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', show);
        this.inert = !show;
        document.body.classList.toggle('has-sticky-atc', show);
      }).observe(target);
    }
  });

  /* ---------- Estimation de livraison (jours ouvrés) ---------- */
  define('delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      const addBusinessDays = (n) => {
        const d = new Date();
        let added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) added += 1;
        }
        return d;
      };
      const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { weekday: 'short', day: 'numeric', month: 'short' });
      const min = Number(this.dataset.min) || 2;
      const max = Math.max(min, Number(this.dataset.max) || min);
      const out = $('[data-delivery-text]', this);
      const parts = (this.dataset.template || '').split(/(\[min\]|\[max\])/);
      out.textContent = '';
      parts.forEach((p) => {
        if (p === '[min]' || p === '[max]') {
          const b = document.createElement('strong');
          b.textContent = fmt.format(addBusinessDays(p === '[min]' ? min : max));
          out.append(b);
        } else out.append(p);
      });
      this.hidden = false;
    }
  });

  /* ---------- Produits recommandés (chargés à l'approche) ---------- */
  define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      const load = () => {
        this.dataset.loaded = 'true';
        fetch(this.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver(([en]) => {
        if (en.isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  });
})();
